import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class PdfDownloadFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.PdfDownload, "MultiJurisdictionCms.Dto.Features.PdfDownloadFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.PdfDownloadFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}